import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SessionCreatePage } from '@/features/sessions/session-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle session interactive : un espace `kernel` et son noyau (ADR 0042 §5). `?code=` suit la session créée. */
export const Route = createFileRoute('/$tenant/sessions/new')({
  validateSearch: (search: Record<string, unknown>): { code?: string } => {
    const code = typeof search['code'] === 'string' ? search['code'].slice(0, 10_000) : '';
    return code.trim() ? { code } : {};
  },
  component: NewSessionRoute,
});

function NewSessionRoute() {
  const { tenant } = Route.useParams();
  const { code } = Route.useSearch();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="sessions"
      crumbs={[{ label: t('sessions.title') }, { label: t('sessions.newTitle') }]}
    >
      <SessionCreatePage tenantId={tenant} {...(code ? { initialCode: code } : {})} />
    </ConsoleShell>
  );
}
